import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-striped table-hover" }
const _hoisted_4 = { scope: "row" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap gap-2"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_badge_with_close = _resolveComponent("bs5-badge-with-close")!
  const _component_bs5_edit_button = _resolveComponent("bs5-edit-button")!
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_delete_button = _resolveComponent("bs5-delete-button")!
  const _component_bs5_group_button = _resolveComponent("bs5-group-button")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!
  const _component_EditUserModal = _resolveComponent("EditUserModal")!
  const _component_SetPasswordModal = _resolveComponent("SetPasswordModal")!
  const _component_AssignDistributorModal = _resolveComponent("AssignDistributorModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Users", -1)),
    _createElementVNode("button", {
      class: "btn btn-success mb-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddUserModal = true))
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1),
      _createTextVNode(" Add User ")
    ])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "table-dark" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { scope: "col" }, "#"),
            _createElementVNode("th", { scope: "col" }, "Full Name"),
            _createElementVNode("th", { scope: "col" }, "Email"),
            _createElementVNode("th", { scope: "col" }, "Role"),
            _createElementVNode("th", { scope: "col" }, "Distributors"),
            _createElementVNode("th", { scope: "col" }, "Actions")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: user.id
            }, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(user.fullName), 1),
              _createElementVNode("td", null, _toDisplayString(user.email), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.getUserRole(user.role)), 1),
              _createElementVNode("td", null, [
                (_ctx.loadingDistributors[user.id as string])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[7] || (_cache[7] = [
                      _createElementVNode("div", {
                        class: "spinner-border spinner-border-sm text-primary",
                        role: "status"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                      ], -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDistributors[user.id as string], (distributor, dIndex) => {
                        return (_openBlock(), _createBlock(_component_bs5_badge_with_close, {
                          key: dIndex,
                          onRemove: ($event: any) => (_ctx.removeDistributor(user, distributor))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(distributor.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onRemove"]))
                      }), 128))
                    ]))
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_bs5_group_button, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_bs5_edit_button, {
                      onClick: ($event: any) => (_ctx.openEditModal(user))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_bs5_base_button, {
                      onClick: ($event: any) => (_ctx.openSetPasswordModal(user))
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("Change password")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_bs5_base_button, {
                      variant: "warning",
                      onClick: ($event: any) => (_ctx.openAssignDistributorModal(user))
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode(" Assign Distributor ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_bs5_delete_button, {
                      onClick: ($event: any) => (_ctx.removeUser(user)),
                      loading: _ctx.removeLoading
                    }, null, 8, ["onClick", "loading"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_AddUserModal, {
      visible: _ctx.showAddUserModal,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddUserModal = false)),
      onUserAdded: _ctx.fetchUsers
    }, null, 8, ["visible", "onUserAdded"]),
    _createVNode(_component_EditUserModal, {
      visible: _ctx.showEditUserModal,
      userId: _ctx.selectedUserId,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEditUserModal = false)),
      onUserUpdated: _ctx.fetchUsers
    }, null, 8, ["visible", "userId", "onUserUpdated"]),
    _createVNode(_component_SetPasswordModal, {
      visible: _ctx.showSetPasswordModal,
      userId: _ctx.selectedUserId,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSetPasswordModal = false)),
      onPasswordSet: _ctx.fetchUsers
    }, null, 8, ["visible", "userId", "onPasswordSet"]),
    _createVNode(_component_AssignDistributorModal, {
      visible: _ctx.showAssignDistributorModal,
      userId: _ctx.selectedUserId,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAssignDistributorModal = false)),
      onDistributorAssigned: _ctx.fetchUsers
    }, null, 8, ["visible", "userId", "onDistributorAssigned"]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-secondary mt-3",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fetchUsers && _ctx.fetchUsers(...args)))
        }, "Refresh"))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[11] || (_cache[11] = [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}